module.exports = __webpack_public_path__ + "static/media/eye.042a8763.svg";